export default "__VITE_PUBLIC_ASSET__ff50f920__"